module.exports = __webpack_public_path__ + "static/media/sociallis-logo-icon.9de0896a.png";